jQuery(document).ready(function($){    
    
  	// Mobile main menu
  	$('.hmburg').click(function(){
  		$('.mainmenu').addClass('showmenu');  
    });    
  	$('.clsmenu, .mainmenu li a').click(function(){
  		$('.mainmenu').removeClass('showmenu');  
    });
  	$('.fitdogtag').click(function(){
  		$('.gf_row.fitpopup').addClass('activeftpop');
      	$('html').addClass('hidescroll');
    });
  	$('.fitclspop').click(function(){
  		$('.gf_row.fitpopup').removeClass('activeftpop');
      $('html').removeClass('hidescroll');
    });
  
  
  
    // Testimonial Slider
    $(".mainsldr").slick({
        autoplay: false,
        dots: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,       
        centerPadding: '0',         
    });
  
    // Testimonial Slider
    $(".cstmrsldr").slick({
        autoplay: false,
        dots: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,       
        centerPadding: '0', 
        fade: true,
        cssEase: 'ease-in-out',       
    });

    $( ".slick-prev").html('<i class="fa fa-angle-left"></i>');
    $( ".slick-next").html('<i class="fa fa-angle-right"></i>');       
  
    // Faq support product
    $('.cmnfaq > .faqdesc').hide(); 
    $('.cmnfaq').click(function(){
  		$(this).find('.faqdesc').slideToggle();
    	$(this).find('.faqtitle').toggleClass('clsfaq'); 
    });
  	
    // Products Grid/List View  
  	 $('.listbtn').click(function(event){
       $('.prodgrid').hide(); 
       $('.prodlists').show();     
     });
     $('.gridbtn').click(function(event){
       $('.prodlists').hide();
       $('.prodgrid').show();             
     });
  
  	 // Product manual pagination
   	 $('.prodmanul .row').paginathing({
      	perPage: 8,
      	insertAfter: '.prodmanul .row',
      	pageNumbers: true
     });
  
  	 //Contact form upload file input validation
     $('#ContactFile').change(function(e){
       	if(this.files[0].size > 307200){
       		alert("File is too big!");
       		this.value = "";
    	};
        $('.fileuploaded').remove(); 	
		var fileName = e. target. files[0]. name;
	 	//$(this).parent().append("<div class='fileuploaded'><span class='filename'>"+fileName+"</span></div>");       
	 });
  
  	 // Product price range filter
     var mi,mx;
		$(function () {			
		      $('#slider-container').slider({
		          range: true,
		          min: 299,
		          max: 1099,
		          values: [299, 1099],
		          create: function() {
		              $("#amount").val("$299 - $1099");
		          },
		          slide: function (event, ui) {
		              $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);                   
		               mi = ui.values[0];
		               mx = ui.values[1];		              
		          }
		      })
		});

		$("#filter__data").on("click",function(){          
			$('.prodsloader').show();
			filterSystem(mi, mx);
		});	

		function filterSystem(minPrice, maxPrice) {
			setTimeout(function(){
		  		$('.prodsloader').hide();
			    $("#filterProducts div.porduct__item").addClass("hideprods").filter(function () {
		          var price = parseInt($(this).data("price"), 10);
		          return price >= minPrice && price <= maxPrice;
		      }).addClass("showprods");
			}, 1000);		     
		}
	
});


function fileValidation(){
		var fileInput = document.getElementById('ContactFile');
		var filePath = fileInput.value;
		var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
		if(!allowedExtensions.exec(filePath)){
			alert('Please upload file having extensions .jpeg/.jpg/.png/.gif only.');
			fileInput.value = '';
			return false;
			}
       	else{
			        //Image preview
			if (fileInput.files && fileInput.files[0]) {
				var reader = new FileReader();
				reader.onload = function(e) {
                  
                  document.getElementById('imagePreview').innerHTML = '<img src="'+e.target.result+'"/>';
				};
             
				reader.readAsDataURL(fileInput.files[0]);
			}
		}
}